import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { userRoles } from "../constants/userRoles";
import { ProgressSpinner } from "primereact/progressspinner";
import HomePage from "../pages/HomePage";
import PublicSitePage from "../pages/PublicSitePage";


import RegistrationCreateEn from "../pages/registration/RegistrationCreateEn";
import RegistrationCreateGu from "../pages/registration/RegistrationCreateGu";
import CreateAd from "../pages/razorpay/CreateAd";
import MyAdvertisements from "../pages/razorpay/MyAdvertisements";

import PrivacyPolicyPublicPage from "../pages/PrivacyPolicyPublicPage";
import TermsConditionPublicPage from "../pages/TermsConditionPublicPage";

// Route-level code splitting -- everything except the public-facing pages
// above is admin-only, so an anonymous website visitor never downloads it.
const LoginPage = React.lazy(() => import("../pages/LoginPage"));
const DashBoardPage = React.lazy(() => import("../pages/dashboard/DashBoardPage"));
const WebsiteAnalyticsPage = React.lazy(() => import("../pages/analytics/WebsiteAnalyticsPage"));
const SearchRankPage = React.lazy(() => import("../pages/searchConsole/SearchRankPage"));
const GithubBrowserPage = React.lazy(() => import("../pages/github/GithubBrowserPage"));
const PlayReviewsPage = React.lazy(() => import("../pages/playReviews/PlayReviewsPage"));
const PlayVitalsPage = React.lazy(() => import("../pages/playVitals/PlayVitalsPage"));
const ServerMonitorPage = React.lazy(() => import("../pages/serverMonitor/ServerMonitorPage"));
const MainLayout = React.lazy(() => import("../components/layouts/MainLayout"));
const ForgetPasswordPage = React.lazy(() => import("../pages/ForgetPasswordPage"));
const SettingPage = React.lazy(() => import("../pages/settings/SettingPage"));
const SurnamePage = React.lazy(() => import("../pages/settings/views/surname/SurnamePage"));
const SurnameCreate = React.lazy(() => import("../pages/settings/views/surname/SurnameCreate"));
const SubCastPage = React.lazy(() => import("../pages/settings/views/subCast/SubCastPage"));
const SubCastCreate = React.lazy(() => import("../pages/settings/views/subCast/SubCastCreate"));
const GovtDepartmentPage = React.lazy(() => import("../pages/settings/views/govtDepartment/GovtDepartmentPage"));
const GovtDepartmentCreate = React.lazy(() => import("../pages/settings/views/govtDepartment/GovtDepartmentCreate"));
const BusinessTypePage = React.lazy(() => import("../pages/settings/views/businessType/BusinessTypePage"));
const BusinessTypeCreate = React.lazy(() => import("../pages/settings/views/businessType/BusinessTypeCreate"));
const BusinessCategoryPage = React.lazy(() => import("../pages/settings/views/businessCategory/BusinessCategoryPage"));
const BusinessCategoryCreate = React.lazy(() => import("../pages/settings/views/businessCategory/BusinessCategoryCreate"));
const RegDocPage = React.lazy(() => import("../pages/settings/views/regDoc/RegDocPage"));
const RegDocCreate = React.lazy(() => import("../pages/settings/views/regDoc/RegDocCreate"));
const RegTypePage = React.lazy(() => import("../pages/settings/views/regType/RegTypePage"));
const RegTypeCreate = React.lazy(() => import("../pages/settings/views/regType/RegTypeCreate"));
const ProductTypePage = React.lazy(() => import("../pages/settings/views/productType/ProductTypePage"));
const ProductTypeCreate = React.lazy(() => import("../pages/settings/views/productType/ProductTypeCreate"));
const BusinessMemTagPage = React.lazy(() => import("../pages/settings/views/businessMemTag/BusinessMemTagPage"));
const BusinessMemTagCreate = React.lazy(() => import("../pages/settings/views/businessMemTag/BusinessMemTagCreate"));
const BazarProductPage = React.lazy(() => import("../pages/settings/views/bazarProduct/BazarProductPage"));
const BazarProductCreate = React.lazy(() => import("../pages/settings/views/bazarProduct/BazarProductCreate"));
const LiveSupportPage = React.lazy(() => import("../pages/liveSupport/LiveSupportPage"));
const EducationRuleCreate = React.lazy(() => import("../pages/settings/views/educationRule/EducationRuleCreate"));
const EducationRuleTreeView = React.lazy(() => import("../pages/settings/views/educationRule/EducationRuleTreeView"));
const EducationRulePage = React.lazy(() => import("../pages/settings/views/educationRule/EducationRulePage"));
const SubAdminPage = React.lazy(() => import("../pages/subAdmin/SubAdminPage"));
const ReportActivitiesPage = React.lazy(() => import("../pages/reportActivities/ReportActivitiesPage"));
const ProfilePage = React.lazy(() => import("../pages/profiles/ProfilePage"));
const ProfileView = React.lazy(() => import("../pages/profiles/ProfileView"));
const AdvertisementPage = React.lazy(() => import("../pages/advertisement/AdvertisementPage"));
const AdvertisementAdd = React.lazy(() => import("../pages/advertisement/AdvertisementAdd"));
const NewLeadsPage = React.lazy(() => import("../pages/newLeads/NewLeadsPage"));
const BusinessPage = React.lazy(() => import("../pages/business/BusinessPage"));
const BusinessAdd = React.lazy(() => import("../pages/business/BusinessAdd"));
const BusinessView = React.lazy(() => import("../pages/business/BusinessView"));
const BusinessViewers = React.lazy(() => import("../pages/business/BusinessViewers"));
const MatriMonialPage = React.lazy(() => import("../pages/matrimonial/MatriMonialPage"));
const JobDescPage = React.lazy(() => import("../pages/jobDesc/JobDescPage"));
const JobAdd = React.lazy(() => import("../pages/jobDesc/JobAdd"));
const JobView = React.lazy(() => import("../pages/jobDesc/JobView"));
const JobViewers = React.lazy(() => import("../pages/jobDesc/JobViewers"));
const ProductPage = React.lazy(() => import("../pages/products/ProductPage"));
const ProductView = React.lazy(() => import("../pages/products/ProductView"));
const ProductViewers = React.lazy(() => import("../pages/products/ProductViewers"));
const ProductAdd = React.lazy(() => import("../pages/products/ProductAdd"));
const StoryPage = React.lazy(() => import("../pages/stories/StoryPage"));
const AboutusPage = React.lazy(() => import("../pages/settings/views/aboutus/AboutusPage"));
const PrivacyPolicyPage = React.lazy(() => import("../pages/settings/views/privacypolicy/PrivacyPolicyPage"));
const ContactusPage = React.lazy(() => import("../pages/settings/views/contactus/ContactusPage"));
const TermsandConditionPage = React.lazy(() => import("../pages/settings/views/termandcondition/TermsandConditionPage"));
const LiveVideoPage = React.lazy(() => import("../pages/settings/views/liveVideo/LiveVideoPage"));
const LiveVideoCreate = React.lazy(() => import("../pages/settings/views/liveVideo/LiveVideoCreate"));
const PageVideoPage = React.lazy(() => import("../pages/settings/views/pageVideo/PageVideoPage"));
const EventPage = React.lazy(() => import("../pages/settings/views/event/EventPage"));
const EventCreate = React.lazy(() => import("../pages/settings/views/event/EventCreate"));
const HomeContentPage = React.lazy(() => import("../pages/settings/views/homeContent/HomeContentPage"));
const ApplicationSettingsPage = React.lazy(() => import("../pages/settings/views/applicationSettings/ApplicationSettingsPage"));
const MatriMonialView = React.lazy(() => import("../pages/matrimonial/MatriMonialView"));
const BazarBhavPage = React.lazy(() => import("../pages/settings/views/bazarBhav/BazarBhavPage"));
const BazarBhavCreate = React.lazy(() => import("../pages/settings/views/bazarBhav/BazarBhavCreate"));
const BazarBhavView = React.lazy(() => import("../pages/settings/views/bazarBhav/BazarBhavView"));
const ActiveUsersPage = React.lazy(() => import("../pages/activeUsers/ActiveUsersPage"));
const ChatPage = React.lazy(() => import("../pages/chat/ChatPage"));
const ActiveUsersCards = React.lazy(() => import("../pages/activeUsers/ActiveUsersCards"));
const BloodGroupPage = React.lazy(() => import("../pages/bloodGroup/BloodGroupPage"));
const AdvertisementPakageCreate = React.lazy(() => import("../pages/settings/views/advertisementPackage/AdvertisementPackageCreate"));
const AdvertisementPakagePage = React.lazy(() => import("../pages/settings/views/advertisementPackage/AdvertisementPackagePage"));
const AdvertisementView = React.lazy(() => import("../pages/advertisement/AdvertisementView"));
const ScheduledNotificationsPage = React.lazy(() => import("../pages/notifications/ScheduledNotificationsPage"));
const NotificationLogsPage = React.lazy(() => import("../pages/notifications/NotificationLogsPage"));
const SystemErrorsPage = React.lazy(() => import("../pages/systemErrors/SystemErrorsPage"));
const BackupsPage = React.lazy(() => import("../pages/backups/BackupsPage"));
const VahanHisabPage = React.lazy(() => import("../pages/vahan/VahanHisabPage"));
const ReelsPage = React.lazy(() => import("../pages/reels/ReelsPage"));
const KhetiHisabPage = React.lazy(() => import("../pages/kheti/KhetiHisabPage"));

const RouteFallback: React.FC = () => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
        <ProgressSpinner />
    </div>
);

const AppRoutes: React.FC = () => (
    <React.Suspense fallback={<RouteFallback />}>
        <Routes>
        <Route
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <MainLayout />
                </ProtectedRoute>
            }
        >
            <Route
                path="/admin"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <DashBoardPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/website-analytics"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <WebsiteAnalyticsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/search-rank"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <SearchRankPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/source-code"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <GithubBrowserPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/play-reviews"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <PlayReviewsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/play-vitals"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <PlayVitalsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/server-monitor"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ServerMonitorPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/backups"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BackupsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <AdvertisementPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <AdvertisementView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/add"
                element={
                    <ProtectedRoute allowedRoles={[userRoles.SUPERADMIN]}>
                        <AdvertisementAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/add/:userid"
                element={
                    <ProtectedRoute allowedRoles={[userRoles.SUPERADMIN]}>
                        <AdvertisementAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/advertisement/edit/:adid"
                element={
                    <ProtectedRoute allowedRoles={[userRoles.SUPERADMIN]}>
                        <AdvertisementAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/profiles"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProfilePage key="verified" pageTitle="Verified Profiles" />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/nonverifiedprofiles"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProfilePage key="nonverified" listEndpoint="/user/nonverifiedlist" pageTitle="Non Verified Profiles" />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/profiles/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProfileView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/add"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/edit/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/business/viewers/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BusinessViewers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/stories"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <StoryPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/livevideos"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <DashBoardPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/matrimonial"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <MatriMonialPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/matrimonial/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <MatriMonialView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobDescPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/add"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/edit/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/jobdesc/viewers/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <JobViewers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/view/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductView />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/viewers/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductViewers />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/add"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/products/edit/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ProductAdd />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/leads"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <NewLeadsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/subadmins"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <SubAdminPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/bloodgroup"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <BloodGroupPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/activeusers"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ActiveUsersCards />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/activeusers/:screen"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ActiveUsersPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/chats"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ChatPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/reportactivities"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ReportActivitiesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/settings"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <SettingPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/livesupport"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <LiveSupportPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/system-errors"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <SystemErrorsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/scheduled-notifications"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ScheduledNotificationsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/notification-logs/:id"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <NotificationLogsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/vahan"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <VahanHisabPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/reels"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <ReelsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin/kheti"
                element={
                    <ProtectedRoute
                        allowedRoles={[
                            userRoles.SUPERADMIN,
                        ]}
                    >
                        <KhetiHisabPage />
                    </ProtectedRoute>
                }
            />
        </Route>
        <Route
            path="/admin/subcast"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SubCastPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/subcast/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SubCastCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/subcast/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SubCastCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/govtdepartment"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <GovtDepartmentPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/govtdepartment/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <GovtDepartmentCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/govtdepartment/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <GovtDepartmentCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav/view/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarBhavView />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/surnames"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SurnamePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/surnames/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SurnameCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/surnames/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SurnameCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationdoc"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegDocPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationdoc/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegDocCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesstype"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessTypePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesstype/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessTypeCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesscategory"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessCategoryPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businesscategory/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessCategoryCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationtype"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegTypePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/registrationtype/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <RegTypeCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/producttype"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ProductTypePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/producttype/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ProductTypeCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businessmemtag"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessMemTagPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/businessmemtag/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BusinessMemTagCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarproducts"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarProductPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarproducts/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <BazarProductCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/bazarbhav"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <SettingPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/aboutus"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AboutusPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/privacypolicy"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <PrivacyPolicyPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/livevideo"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <LiveVideoPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/livevideo/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <LiveVideoCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/livevideo/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <LiveVideoCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/event"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EventPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/event/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EventCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/event/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EventCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/pagevideo"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <PageVideoPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/homecontent"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <HomeContentPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/applicationsettings"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ApplicationSettingsPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/contactus"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <ContactusPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/termsandcondition"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <TermsandConditionPage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRulePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/tree"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleTreeView />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/educationrule/tree/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <EducationRuleTreeView />
                </ProtectedRoute>
            }
        />

        <Route
            path="/admin/advertisementpackage"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AdvertisementPakagePage />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/advertisementpackage/create"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AdvertisementPakageCreate />
                </ProtectedRoute>
            }
        />
        <Route
            path="/admin/advertisementpackage/edit/:id"
            element={
                <ProtectedRoute
                    allowedRoles={[
                        userRoles.SUPERADMIN,
                    ]}
                >
                    <AdvertisementPakageCreate />
                </ProtectedRoute>
            }
        />

        <Route path="/" element={<HomePage />} />
        <Route path="/p/:slug" element={<PublicSitePage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicyPublicPage />} />
        <Route path="/termsandcondition" element={<TermsConditionPublicPage />} />
        <Route path="enregister" element={<RegistrationCreateEn />} />
        <Route path="guregister" element={<RegistrationCreateGu />} />
        <Route path="/advertisement/:userid" element={<CreateAd />} />
        <Route path="/advertisement/:userid/my" element={<MyAdvertisements />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin/forgetpassword" element={<ForgetPasswordPage />} />

        {/* Any unmatched path (public or admin) bounces to the homepage
            instead of rendering blank — no dedicated 404 page by design. */}
        <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </React.Suspense>
);

export default AppRoutes;
